import { render } from "./ethetical-collaborations-philosophy.vue?vue&type=template&id=cd969128&scoped=true"
import script from "./ethetical-collaborations-philosophy.vue?vue&type=script&lang=js"
export * from "./ethetical-collaborations-philosophy.vue?vue&type=script&lang=js"

import "./ethetical-collaborations-philosophy.vue?vue&type=style&index=0&id=cd969128&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd969128"]])

export default __exports__